import { graphql } from 'gatsby';
import React from 'react';
import { BackgroundColorTheme } from '../../../templates/Page';
import { CommonModuleProps } from '../../ModulesContent';

export const ThemeModuleFragment = graphql`
  fragment ThemeModule on SanityThemeModule {
    theme
  }
`;

export type ThemeModuleProps = {
  theme: BackgroundColorTheme;
  className?: string;
};

function ThemeModule(props: ThemeModuleProps & CommonModuleProps): React.ReactElement {
  const { className, moduleId } = props;

  return <></>;
}

export default ThemeModule;
